<template>
  <AsteonlineCard>
    <CardHead>
      <div class="flex items-center">
        <div class="flex-grow">
          <ChatBubbleBottomCenterIcon class="h-4 w-4 mr-2 inline-block" />
          {{ auction.name }}
        </div>
        <div class="text-xs">
          {{ $t("auction.opening") }} {{ dateUtils.format(auction.startAt) }}
          <br class="md:hidden">
          <span class="hidden md:inline"> - </span>
          {{ $t("auction.closing") }}
          {{ calculatedEndedAt }}
        </div>
      </div>
    </CardHead>

    <CardBody>
      <div class="flex items-center">
        <div class="flex-grow">
          <AuctionDetails :auction="auction" />
        </div>
        <div>
          <RouterLink :to="'/aste/' + auction.uuid"
            class="bg-corepla-dark block text-white hover:bg-corepla-bg-dark px-8 py-1 rounded text-center border-b-2 border-b-corepla-dark shadow">
            {{ $t("auction.details") }}
          </RouterLink>
        </div>
      </div>
    </CardBody>
  </AsteonlineCard>
</template>

<script setup>
import { ChatBubbleBottomCenterIcon } from '@heroicons/vue/24/solid';

import AuctionDetails from '@/components/auction/AuctionDetails.vue';
import dateUtils from '@/services/date-utils';

import AsteonlineCard from './card/AsteonlineCard.vue';
import CardBody from './card/CardBody.vue';
import CardHead from './card/CardHead.vue';
import { computed } from 'vue';

const props = defineProps({
  auction: {
    type: Object,
    required: true
  }
})

const calculatedEndedAt = computed(() => {
  return props.auction.redistributeEndAt ?
    dateUtils.format(props.auction.redistributeEndAt) : (
      props.auction.effectiveEndAt ?
        dateUtils.format(props.auction.effectiveEndAt) :
        dateUtils.format(props.auction.endAt)
    );
})
</script>